/**
 * 악덕알리미 로그인 처리 뒤 중간 화면 (POST /b/login 응답) — 메시지가 있으면 알리고 목적지로 간다
 * ($j.Pages.Devil.LoginAfter / body data-page-name="LoginAfter")
 *
 * 이 뷰는 body 에 마크업이 없는 중간 페이지다. href 로 이동하면 히스토리에 남아 뒤로가기 시
 * 빈 화면이 보인다 → replace 로 현재 항목을 교체한다 (devil 의 다른 내비게이션과 같은 방식).
 */
export default class LoginAfter {
    initialize() {
        const d = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
        const goPage = () => setTimeout(() => location.replace(d.url || '/b'), 300);

        if (d.message) $j.Common.Util.swalert(d.message, goPage);
        else goPage();
    }
}
